import rollbarLogger from "../utilities/rollbarLogger"

const createErrorSlice = (set, get) => ({
  logError: (message, err) => {
    const logger = rollbarLogger(get().user)
    logger.logError(message, err)
    get().setErrMessage(message)
  }
})

export default createErrorSlice